import { FormattedMessage } from "react-intl";

export const RichFormattedMessage = ({
  id,
  values,
}: {
  id: string;
  values?: Record<string, any>;
}) => {
  return (
    <FormattedMessage
      id={id}
      values={{
        br: () => <br />,
        bullet: <span>&#8226; </span>,
        b: (chunks) => <b>{chunks}</b>,
        ...values,
      }}
    />
  );
};
